/**
 * Webhooks de Meta llegan a api.dev.wembii.com; el socket debe usar el mismo
 * cluster Redis, no localhost:15000, cuando el usuario abre dev.wembii.com.
 */
export function resolveSocketUrl(): string {
  const envUrl = process.env.REACT_APP_SOCKET_URL;

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const useLocalProxy =
      envUrl &&
      (envUrl.startsWith("/") ||
        envUrl.includes(`${host}:${window.location.port}`));

    if (useLocalProxy) {
      return window.location.origin;
    }

    if (
      host === "dev.wembii.com" ||
      host === "app.dev.wembii.com" ||
      host.endsWith(".dev.wembii.com")
    ) {
      return "https://api.dev.wembii.com";
    }
    if (host === "app.wembii.com" || host.endsWith(".wembii.com")) {
      return "https://api.wembii.com";
    }
  }

  return envUrl || "http://localhost:15000";
}
